import { defineStore } from 'pinia'
import { ref } from 'vue'

import { AlertType } from '@/constants/ui'

interface AlertConfig {
  alertType: AlertType
  message: string
  cancelLabel?: string
  ctaLabel?: string
  messageTitle?: string
  onSubmit?(): Promise<void> | void
}

export const useAlertManagerStore = defineStore('alertManager', () => {
  const alertVisible = ref(false)
  const alertType = ref<AlertType>(AlertType.info)
  const cancelLabel = ref<string | undefined>(undefined)
  const ctaLabel = ref<string | undefined>(undefined)
  const loading = ref(false)
  const message = ref('')
  const messageTitle = ref<string | undefined>(undefined)
  const onSubmit = ref<(() => Promise<void> | void) | null>(null)

  const openAlert = (config: AlertConfig): void => {
    alertType.value = config.alertType
    cancelLabel.value = config.cancelLabel
    ctaLabel.value = config.ctaLabel
    message.value = config.message
    messageTitle.value = config.messageTitle

    onSubmit.value = config.onSubmit ? (): Promise<void> | void => config.onSubmit?.() : null
    alertVisible.value = true
  }

  const closeAlert = (): void => {
    alertVisible.value = false
    loading.value = false
    onSubmit.value = null
  }

  const submitAlert = async (): Promise<void> => {
    if (!onSubmit.value || loading.value) return

    try {
      loading.value = true
      await onSubmit.value()
      closeAlert()
    } catch {
      // eslint-disable-next-line require-atomic-updates
      loading.value = false
    }
  }

  return {
    alertType,
    alertVisible,
    cancelLabel,
    closeAlert,
    ctaLabel,
    loading,
    message,
    messageTitle,
    openAlert,
    submitAlert,
  }
})
